export default function AppFieldStack({ size = "md", className = "", style, children }) {
  const sizeClass =
    size === "sm" ? "ds-field-stack--sm" : size === "lg" ? "ds-field-stack--lg" : "ds-field-stack--md";
  const classes = ["ds-field-stack", sizeClass, className].filter(Boolean).join(" ");

  return (
    <div className={classes} style={style}>
      {children}
    </div>
  );
}
